import { Component, Input, Output, EventEmitter, OnDestroy, ChangeDetectorRef, ViewContainerRef, OnInit } from '@angular/core';
import { SharedChangesService, StorageService, APIFacadeService, NextInterface, ErrorInterface, CompleteInterface, API_TYPES, ERROR_TYPES } from '@shared/services';
import { TranslateService } from '@shared/services/translate';
import { NotificationService } from '@shared/services/dialogs/notification.service';
import { DialogsService } from '@shared/services/dialogs/dialogs.service';
import { UntypedFormControl } from '@angular/forms';
import { StaffSwitcherComponent } from '../staff-switcher/staff-switcher.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ScreenLockerSheetComponent } from '../screen-locker-sheet/screen-locker-sheet.component';
import { Account } from '@shared/models/account/account.class';
import { CacheMapService } from '@shared/services/cache';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';


@Component({
    selector: 'shopbox-staff-profile',
    templateUrl: './staff-profile.component.html',
    styleUrls: ['./staff-profile.component.scss'],
    providers: [APIFacadeService],
    imports: [MatButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, TranslatePipe]
})
export class StaffProfileComponent implements OnDestroy {
  @Input() profile: any;
  @Output() logout: EventEmitter<any> = new EventEmitter<any>();
  staff: any[] = [];

  menuIcon: string = 'expand_more';
  pinCodeCtrl: UntypedFormControl = new UntypedFormControl();
  defaultSrc: string = 'assets/core/dummy2.png';

  constructor(
    private _sharedChanges: SharedChangesService,
    private _storage: StorageService,
    private _api: APIFacadeService,
    private _notify: NotificationService,
    private _changeDetectRef: ChangeDetectorRef,
    private _dialog: DialogsService,
    private _viewRef: ViewContainerRef,
    private _bottomSheet: MatBottomSheet,
    private _cache: CacheMapService,
    private _router: Router,
    public translate: TranslateService
  ) {
    this.watchClient();
    this.watchLockerScreen();
    this.subscribeToApi();
    this.getProfile();
    this.watchRouting();
  }

  watchRouting() {
    const routerChanges = this._router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((data: NavigationEnd) => {
        if (data.url.includes('counter-screen') && this._storage.getLockerScreen()) {
          this.lockCounter();
        }
      });
    this._api.subscriptionList.add(routerChanges);
  }


  watchLockerScreen() {
    const sharedLockerSub = this._sharedChanges.screenLockerChange.subscribe((res) => {
      if (res) {
        this.openCounterLockerSheet();
      }
    });
    this._api.subscriptionList.add(sharedLockerSub);
  }

  subscribeToApi() {
    this._api.subscribeToApi( this._changeDetectRef, 400);
    this._api.nextEmit.subscribe((res: NextInterface) => {
      this.nextFnApi(res.res, res.apiType);
    });
    this._api.errorEmit.subscribe((res: ErrorInterface) => {
      this.errorFnApi(res.error, res.errorType);
    });
    this._api.completeEmit.subscribe((res: CompleteInterface) => {
      this.completeFnApi(res.apiType);
    });
  }

  nextFnApi(res: any, type: API_TYPES) {
    switch (type) {
      case API_TYPES.GET_ACCOUNTS:
        this.setCurrentStaff(res);
        break;
      case API_TYPES.GENERATE_TOKEN:
        this.setNewToken(res);
        break;

      default:
        break;
    }
  }

  errorFnApi(error: any, type: ERROR_TYPES) {
    switch (type) {
      case ERROR_TYPES.NORMAL:
        if (typeof error === 'string') {
          this._notify.show(error, null, null, true);
        } else if (typeof error.message === 'string') {
          this._notify.show(error.message, null, null, true);
        }
        break;

      default:
        break;
    }
  }

  completeFnApi(type: API_TYPES) {
    switch(type) {
      case API_TYPES.GET_ACCOUNTS:
        if (location.hash.includes('counter-screen') && this._storage.getLockerScreen()) {
          this.lockCounter();
        }
        break;
      default:
        this._changeDetectRef.markForCheck();
        break;
    }
  }

  watchClient() {
    const sub = this._sharedChanges.currentClientChange.subscribe((res) => {
      this.getProfile();
    });
    this._api.subscriptionList.add(sub);
  }

  getProfile() {
    this.getStorageProfile();
    this.getStaff();
  }

  getStaff() {
    const getStaff = this._api.shopboxApiService.staffService.getStaff(null, -1);
    this._api.apiType = API_TYPES.GET_ACCOUNTS;
    this._api.errorType = ERROR_TYPES.NORMAL;
    this._api.apiSubject.next(getStaff);
  }

  setCurrentStaff(res: any) {
    this.staff = res.data;
    const index = this.staff.findIndex(element => element.account0.uid === this.profile.uid);
    if (index !== -1) {
      this.staff[index]['recent'] = true;
    }
  }

  closedMenu() {
    this.menuIcon = 'expand_more';
  }

  openedMenu() {
    this.menuIcon = 'expand_less';
  }

  /**
   * keyPress
   * @function
   * @description check for numbers
   * @param {MouseEvent} event
   * @returns {boolean}
   */
  keyPress(event: KeyboardEvent): boolean {
    let input: string;
    const e = event;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  }

  openSwitcher(event: MouseEvent, btn: any) {
    event.stopPropagation();
    const dataSource = this.staff;
    const dialog = this._dialog.customTest(StaffSwitcherComponent, this._viewRef, null, null, null, null, dataSource);
    dialog.updatePosition({right: '80px', top: '100px'});
    const dialogSub = dialog.afterClosed().subscribe((res) => {
      if (res && res.result) {
        if (res.staff) {
          this.setStaff(res.staff, res.pinCode);
        }
      }
    });
    this._api.subscriptionList.add(dialogSub);
  }

  setStaff(staff: any, pinCode: number) {
    const index = this.staff.findIndex(element => element.uid === staff.uid);
    if (!pinCode) {
      pinCode = this.staff[index]['user_code'];
    } else {
      this.staff[index]['user_code'] = pinCode;
    }
    if (this.staff[index]['account0']['uid'] !== this.profile.uid) {
      this.generateToken(pinCode);
    }
    this.staff[index]['recent'] = true;
    this.staff[index]['account0']['crdate'] = staff['crdate'];
    this.staff[index]['account0']['code'] = this.staff[index]['code'];
    if (this._storage.getTokenTemp()) {
      this._storage.setAccountTemp(this.staff[index]['account0']);
    } else {
      this._storage.setAccount(this.staff[index]['account0']);
    }
    this.getStorageProfile(this.staff[index]['account0']);
  }

  generateToken(pinCode: number) {
    this._cache.deleteAllCachesContain(Account.GenerateTokenByBinURL);
    const generateTokenSub = this._api.shopboxApiService.accountService.generateToken({
      code: pinCode
    });
    this._api.apiType = API_TYPES.GENERATE_TOKEN;
    this._api.errorType = ERROR_TYPES.NORMAL;
    this._api.apiSubject.next(generateTokenSub);
  }

  getStorageProfile(staff?: any) {
    this.profile = staff ? staff : this._storage.getAccount();
    this._changeDetectRef.markForCheck();
  }

  lockCounter() {
    this._storage.setLockerScreen(true);
    this._sharedChanges.screenLockerChange.next(true);
  }

  openCounterLockerSheet() {
    const sheetSub = this._bottomSheet.open(ScreenLockerSheetComponent, {
      disableClose: true,
      closeOnNavigation: true,
      data: this.staff
    }).afterDismissed().subscribe((res) => {
      if (res && res.result) {
        if (res.staff) {
          this.setStaff(res.staff, res.pinCode);
        }
      }
    });
    this._api.subscriptionList.add(sheetSub);
  }

  setNewToken(res: any) {
    res['account']['crdate'] = res['crdate'];
    if (this._storage.getToken()) {
      this._storage.setToken(res['accessToken']);
      this._storage.setAccount(res['account']);
    } else {
      this._storage.setTokenTemp(res['accessToken']);
      this._storage.setAccountTemp(res['account']);
    }
    this._cache.deleteAllCachesContain(Account.AccountSettingsURL);
  }

  ngOnDestroy() {
    this._api.destroy();
  }

}
